import { ChargeDetailConstant } from "../ChargeDetailMaintenance/ChargeDetailConstant";

export const counterCustomerChargeMaintenanceRequiredFieldList: string[] = [
    'counterCustomerCharge',
];

export const CounterCustomerChargeMaintenanceConstant = {
    CATEGORY: "Counter Charge",
    TITLE: "Counter Charge Details",
    SEARCH_CRITERIA: ChargeDetailConstant.Charge.SEARCH_CRITERIA,
    Search: {
        CHARGE_TYPE: 'Charge Type',
        SUB_CHARGE_TYPE: 'Sub Charge Type',
        OPS_LINE: 'Ops Line',
        OPS_DATE_RANGE: 'Ops Date Range',
        CONS_VSL_VOY: 'Co/Vsl/Voy',
        CNTR_NO: 'Container No./Vehicle No.',
        CHARGE_ON_COMPANY: 'Charge-On Company',
        BILL_TO_COMPANY: 'Bill-To Company',
        BILL_OF_LADING: 'Bill of Lading/Ref. No.',
        SHIPPING_BILL: 'Shipping Bill',
        AGENT_NO: 'Agent No.',
        STATE: 'State',
        SUB_SERVICE_REQUEST_CODE: 'Sub-Service Request Code',
        SERVICE_REQUEST_CODE: 'Service Request Code',
        SERVICE_REQUEST_REF: 'Service Request Ref.',
        TRAIN_ID: 'Train ID',
    },
    Detail: {
        STATE: 'State',
        SEQ_NO: 'Seq No.',
        CHARGE_ON_COMPANY: 'Charge-On Company',
        BILL_TO_COMPANY: 'Bill-To Company',
        BILL_TO_COMPANY_NAME: 'Bill-To Company Name',
        CONSORTIUM_CODE: 'Consortium Code',
        VESSEL_CODE: 'Vessel Code',
        VOYAGE_CODE: 'Voyage Code',
        ETD: 'ETD',
        CHARGE_TYPE: 'Charge Type',
        SUB_CHARGE_TYPE: 'Sub Charge Type',
        CONTAINER_NO: 'Container No.',
        STATUS: 'Status',
        SIZE: 'Size',
        TYPE: 'Type',
        SERVICE_ORDER_CODE: 'Service Order Code',
        SERVICE_ORDER_NUMBER: 'Service Order Number',
        TARIFF_TYPE: 'Tariff Type',
        TARIFF_CODE: 'Tariff Code',
        QTY: 'Qty',
        UOM: 'UOM',
        OPS_LINE: 'Ops Line',
        CNIC_NO: 'CNIC No.',
        VEHICLE_NO: 'Vehicle No.',
        DAMAGE_TYPE: 'Damage Type',
        AMOUNT: 'Amount',
        REMARKS: 'Remarks',
        COMMODITY_CODE: 'Commodity Code',
        SHIPPER_CONSIGNEE: 'Shipper/Consignee',
        DRAFT_INVOICE_NO: 'Draft Invoice No.',
        FINAL_INVOICE_NO: 'Final Invoice No.',
        DRAFT_CREDIT_NOTE_NO: 'Draft Credit Note No.',
        FINAL_CREDIT_NOTE_NO: 'Final Credit Note No.',
        ADJ_TYPE: 'Adj. Type',
        MANUAL_CHARGE_NO: 'Manual Charge No.',
        CREDIT_CHARGE_NO: 'Credit Charge No.',
        CONTAINER_TYPE_GROUP: 'Container Type Group',
        OPS_DATE: 'Ops Date',
        BILL_OF_LADING_NO: 'Bill of Lading / Ref. No.',
        SHIPPING_BILL: 'Shipping Bill',
        SERVICE_CODE: 'Service Code',
        SERVICE: 'Service',
        AGENT_NO: 'Agent No.',
        AGENT_NAME: 'Agent Name',
        PAID_THROUGH_DATE: 'Paid Through Date',
        OPERATING_TML: 'Operating Tml',
        CHANGE_DATE: 'Change Date/Time',
        RELEASE_DATE: 'Release Date/Time',
        ONE_OFF_RATE: 'One-Off Rate',
        SPECIAL_IND: 'Special Ind.',
        VESSEL_NAME: 'Vessel Name',
        ORI_OWNER: 'Ori Owner',
        OWNER: 'Owner',
        ORI_STATUS: 'Ori Status',
        NEW_OWNER: 'New Owner',
        OTHER_OWNER: 'Other Owner',
        NEW_STATUS: 'New Status',
        CHARGE_CODE: 'Charge Code',
        TELEX_NO: 'Telex No.',
        CHARGE_IND: 'Charge Ind.',
        SHIPMENT_TYPE: 'Shipment Type',
        FORWARDER_REF: 'Forwarder Ref.',
        BARGE_JOB_ID: 'Barge Job Id',
        ARR_DATE: 'Arr Date/Time',
        OTHER_ARR_DATE: 'Other Arr Date/Time',
        OTHER_DEP_DATE: 'Other Dep Date/Time',
        OTHER_SERVICE: 'Other Service',
        POD2: 'POD2',
        POD_GEOG_IND: 'POD Geog Ind.',
        REQUEST_DATE: 'Request Date/Time',
        REASON_CODE: 'Reason Code',
        RECEIVE_DATE: 'Receive Date/Time',
        LOADING_DATE: 'Loading Date/Time',
        FIRST_LOADING_DATE: 'First Loading Date/Time',
        LAST_LOADING_DATE: 'Last Loading Date/Time',
        POWER_CONSUMPTION_START_DATE: 'Power Consumption Start Date',
        POWER_CONSUMPTION_END_DATE: 'Power Consumption End Date',
        NO_OF_POWER_CONSUMPTION_DATE: 'No. of Power Consumption Date',
        CHARGING_FROM_DATE: 'Charging From Date/Time',
        CHARGING_TO_DATE: 'Charging To Date/Time',
        FROM: 'From',
        TO: 'To',
        RECEVAL_CUTOFF_TIME: 'Receval Cutoff Time',
        FIRST_TIER_FSP: '1st Tier FSP',
        SECOND_TIER_FSP: '2nd Tier FSP',
        CHARGING_QTY_ADJUST: 'Charging Qty Adjust',
        CALENDAR_ADJUST_CHARGE_QTY: 'Calendar Adjust Charge Qty',
        MANUAL_ADJUST_CHARGE_QTY: 'Manual Adjust Charge Qty',
        MANUAL_ADJUST_UOM: 'Manual Adjust UOM',
        DG_CONTENT: 'DG Content',
        DU_CONTENT: 'DU Content',
        PERMIT_NO: 'Permit No',
        RF_TEMP: 'RF Temp.',
        RF_TEMP_UNIT: 'RF Temp. Unit',
        DIRECT_INDIRECT_DISCHARGE_IND: 'Direct/Indirect Discharge Ind.',
        SO_NUMBER: 'SO Number',
        TRAIN_ID: 'Train ID',
        RAIL_OPERATOR: 'Rail Operator',
        TRACTOR_NO: 'Tractor No.',
        FD_GEOG_IND: 'FD Geog Ind.',
        WAIVER_NO: 'Waiver No.',
        POO_GEOG_IND: 'POO Geog Ind.',
        POL_GEOG_IND: 'POL Geog Ind.',
        EQUIPMENT_CODE_IND: 'Equipment Code Ind.',
        EQUIPMENT_CODE: 'Equipment Code',
        NO_OF_STORAGE: 'No. of Storage',
        DISCHARGE_DATE: 'Discharge Date/Time',
        FIRST_DISCHARGE_DATE: 'First Discharge Date/Time',
        LAST_DISCHARGE_DATE: 'Last Discharge Date/Time',
        EXPIRY_DATE: 'Expiry Date/Time',
        DELIVERY_DATE: 'Delivery Date/Time',
        ATB_DATE: 'ATB Date/Time',
        CASH_OT_DAYS: 'Cash OT Days',
        CASH_AMOUNT: 'Cash Amount',
        CASH_RECEIPT_NO: 'Cash Receipt No.',
        IMCO_CODE: 'IMCO Code',
        SPECIAL_CODE: 'Special Code',
        SPECIAL_HANDLING_IND: 'Special Handling Ind.',
        POO: 'POO',
        POD: 'POD',
        POL: 'POL',
        FD: 'FD',
        POO_COUNTRY: 'POO Country',
        POD_COUNTRY: 'POD Country',
        POL_COUNTRY: 'POL Country',
        FD_COUNTRY: 'FD Country',
        EXCESS_WEIGHT: 'Excess Weight',
        GROSS_WEIGHT: 'Gross Weight',
        MAX_GROSS_WEIGHT: 'Max Gross Weight',
        CARGO_CODE: 'Cargo Code',
        WAIVER_REASON_CODE: 'Waiver Reason Code',
        WAIVER_REJECT_REASON: 'Waiver Reject Reason',
        WAIVER_REVERSE_REASON_CODE: 'Waiver Reverse Reason Code',
        WAIVER_APPROVED_BY: 'Waiver Approved By',
        WAIVER_APPROVED_DATE: 'Waiver Approved Date',
        EXCISE_CASH_NO: 'Excise Cash No.',
        LIFT_ON_OFF_IND: 'Lift On/Off Ind.',
        NO_OF_WAIVED_DAYS: 'No. of Waived Days',
        WE_BOC: 'WeBOC',
        SERVICE_REQUEST_REF: 'Service Request Ref.',
        SERVICE_REQUEST_CODE: 'Service Request Code',
        SUB_SERVICE_REQUEST_CODE: 'Sub-Service Request Code',
        EXCEPTION_MSG: 'Exception Msg',
        CONS_VSL_VOY_VESSEL_NAME: 'Cons/Vsl/Voy/Vessel Name',
        GATE_IN_DATE: 'Gate In Date',
        POWER_PLUG_ON_DATE: 'Power Plug On Datetime',
        POWER_PLUG_OFF_DATE: 'Power Plug Off Datetime',
        ADJUSTMENT_TYPE: 'Adjustment Type',
        DG_SURCHARGE_IND: 'DG Surcharge Ind.',
        OOG_SURCHARGE_IND: 'OOG Surcharge Ind.',
        CHARGE_QTY: 'Charge Qty',
        ESN_STATUS: 'ESN Status',
        CRO_STATUS: 'CRO Status',
        HOLD_CODE_LIST: 'Hold Code List',
        HANDLING_DATE_TIME: 'Handling Date/Time',
        TRANSFER_FROM_SL: 'Transfer From SL',
        LOCATION_TYPE: 'Location Type',
        VATTIN: 'Vattin',
        STUFFING_REQUEST: 'Stuffing / Unstuffing Request',
        CONTAINER_OPEN_TIME: 'Container Open Time',
        CONTAINER_CLOSE_TIME: 'Container Close Time',
        NO_OF_LABOR: 'No. Of Labor',
        GATE_IN_DATE_TIME: 'Gate In Date/Time',
        GATE_OUT_DATE_TIME: 'Gate Out Date/Time',
        AGENT_DELIVERY_DATE: 'Agent Delivery Date',
        COUSTOMS_DECLARATION_NO: 'Customs Declaration No.',
        SEQUENCE_NUMBER: 'Booking Seq. No',
        PREVIOUS_PAID_THROUGH_DATE: 'Previous Paid Through Date',
        CNTR_NO_REF: 'Cntr No. Ref',
    },
    BUTTON: {
        MARK_MT: "Mark MT",
        UPDATE_INVOICE_INFO: "Update Invoice Info",
        UPDATE_PAID_THROUGH_DATE: "Update Paid Through Date",
        PREVIEW: "Preview",
        UPDATE_CHARGE_ON_COMPANY: "Update Charge-On Company",
        UPDATE_BILL_TO_COMPANY: "Update Bill-To Company",
        WAIVER_REASON_CODE: "Waiver Reason Code",
        EDIT_WAIVER: "Edit Waiver",
        SUPPLEMENTARY_WAIVER: "Supplementary Waiver",
        DELETE: "Delete",
        ADJUSTMENT: "Adjustment",
        CHARGE_QTY: "Charge Qty",
        EXTRA_LABOR: "Extra Labor",
        ACCOUNT_TERMINAL: "Account Terminal / Resume",
        HOLD: "Hold / Un-Hold",
        STUFFING: "CFS Stuffing & Unstuffing",
        RE_HANDLING: "Import Re-Handling",
        UPDATE_AGENT_DELIVERY_DATE: "Update Agent Delivery Date",
        EXTENSION_PAYMENT: "Extension Payment",

    },
    VESSEL: {
        TITLE: 'Additional Charge Vessel List',
        CHARGE_ON_COMPANY: 'Charge-On Company',
        BILL_TO_COMPANY: 'Bill-To Company',
        CONSORTIUM_CODE: 'Consortium Code',
        VESSEL_CODE: 'Vessel Code',
        VOYAGE_CODE: 'Voyage Code',
        VESSEL_NAME: 'Vessel Name',
        SERVICE_CODE: 'Service Code',
        SL_VESSEL_CODE: 'S/L Vessel Code',
        SL_IB_VOYAGE_CODE: 'S/L IB Voyage Code',
        SL_OB_VOYAGE_CODE: 'S/L OB Voyage Code',
        ARR_DATE_TIME: 'Arr Date/Time',
        DEP_DATE_TIME: 'Dep Date/Time',
        SOA: 'SOA',
        LOA: 'LOA',
        OPERATING_TML: 'Operating TML',
    },
    PAYMENT: {
        TITLE: 'Payment Mode Additional Information',
        PAYMENT_MODE: 'Payment Mode',
        PAYMENT_AMOUNT: 'Payment Amount',
        PAY_ORDER_NO: 'Pay Order No.',
        CREDIT_CARD_NO: 'Credit Card No.',
        BANK_CODE: 'Bank Code',
        PAY_ORDER_AMOUNT: 'Pay Order Amount',
        INVOICE_AMOUNT: 'Invoice Amount',
        SHIPPING_AGENT: 'Shipping Agent',
        OBSERVATION: 'Observation',
        CUSTOMS_DECLARATION_NO: 'Customs Declaration No.',
        CUSTOMS_DECLARATION_DATE: 'Customs Declaration Date',
        AGENT_DELIVERY_DATE: 'Agent Delivery Date',
    }
}
